<template>
    <div class="notification-alert"
         :class="{'notification-alert--courses' : isCourses}"
    >
        <a class="link" href="javascript:void(0)">
            <img :src="env.public_base + '/assets/images/notification-icon.svg' | imgSrc" v-if="!isCourses" alt="">
            <i class="fa fa-bell" v-else></i>

            <p v-if="notification && notification.isActive && notification.text">{{ notification.text }}</p>
        </a>

        <button type="button" @click="hideNotificationAlert">
            <img :src="env.public_base + '/assets/images/cross-icon--bold.svg'" alt="">
        </button>
    </div>
</template>

<script>
    import env from '../env';
    import { mapGetters } from 'vuex';

    export default {
        name: "Notification",
        data: () => ({
            env,
            blocker: false,
        }),
        computed: {
            ...mapGetters([
                'notification'
            ]),
            isCourses() {
                return this.$router.options.base === '/courses'
            },
            test() {return this.notification}
        },
        methods:{
            hideNotificationAlert(){
                this.$emit('hideNotificationAlert');
                this.$store.commit('SET_NOTIFICATION_ALERT',  {text: '', isActive: false});
            },
            hide() {
                let $vm = this;
                this.blocker = true;
                setTimeout(() => {
                    $vm.hideNotificationAlert();
                    this.blocker = false;

                }, 3000);
            }
        },
        watch: {
            notification(val) {
                if(val && !this.blocker) this.hide();
            }
        },
        created() {
            this.hide();
        }
    }
</script>

<style scoped>

</style>
